<template>
    
                        <div v-if="poll.pollID" class="widget widget--border-box peoples-poll">
                            <div class="widget__title has-ajax-load">
                                <h4>Anketa</h4>
                            </div>
                            <div class="pool-box">
                                <h5>{{ poll.question }}</h5>
                                <ul>
                                    <li v-for="(pollAnswer, i) in poll.pollAnswers" :key="i" class="c-input c-input--radio">
                                        <div v-on:click="setPollAnswerID(pollAnswer.pollAnswerID)" class="radio">
                                            <input v-if="!poll.pollAnswerID" v-bind:id="'radio-'+i" name="radio" type="radio">
                                            <label v-bind:for="'radio-'+i" class="radio-label" v-bind:style="{paddingLeft: poll.pollAnswerID? '0px' : '25px', fontWeight: poll.pollAnswerID === pollAnswer.pollAnswerID? 'bold' : 'unset'  }">{{ pollAnswer.answer }} <span v-if="poll.pollAnswerID">({{ pollAnswer.votes }})</span></label>
                                        </div>
                                    </li>
                                </ul>
                                <div v-if="!poll.pollAnswerID" class="pool-btn-group">
                                    <button v-on:click="vote()" class="c-btn c-btn--solid submit c-btn--color-brand" v-bind:class="{'c-bnt-disabled': !answerSelected }" v-bind:disabled="!answerSelected">Glasaj</button>
                                </div>
                            </div>
                        </div>

</template>

<script>
    import { IpAddressService } from '../common/api.service'
    import { PollService } from '../common/api.service'

    export default {
        name: "Poll",
        data() {
            return {
                poll: {},
                pollAnswerID: null,
                answerSelected: false,
                userIpAddress: null
            }
        },
        mounted() {
            IpAddressService.get().then(res => { this.userIpAddress = res.data.ip; this.fetchData(); });
        },            
        methods: {
            fetchData: function() {
                PollService.getActivePoll(this.userIpAddress).then(res => {
                    this.poll = res.data;
                });
            },
            setPollAnswerID: function(pollAnswerId) {
                this.pollAnswerID = pollAnswerId;
                this.answerSelected = true;
            },
            vote: function() {
                if(this.pollAnswerID === null)
                    return;
                PollService.vote(this.poll.pollID, this.pollAnswerID, this.userIpAddress).then(res => {
                    this.poll = res.data;
                });
            }
        }
    }
</script>

<style scoped>
    .peoples-poll .pool-btn-group {
        margin-top: 10px;
    }

    .c-bnt-disabled {
        opacity: 0.5;
    }
</style>



// WEBPACK FOOTER //
// src/components/Poll.vue